var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "chatbot-status-widget" },
    [
      _c(
        "md-button",
        {
          ref: "buttonRef",
          staticClass:
            "actionButtonBreadcrumb m-0 chatbot-btn chatbot-status-button",
          staticStyle: { "min-width": "20px", "max-width": "25px" },
          on: {
            mouseenter: function ($event) {
              _vm.chatbotIconHovered = true
            },
            mouseleave: function ($event) {
              _vm.chatbotIconHovered = false
            },
            click: _vm.toggleDropdown,
          },
        },
        [
          _c("ChatbotIcon", {
            staticClass: "chatbot-icon",
            attrs: {
              color:
                _vm.chatbotIconHovered || _vm.isDropdownVisible
                  ? _vm.getIconColor()
                  : "#3A3F48",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.isDropdownVisible
        ? _c(
            "div",
            {
              staticClass: "chatbot-custom-dropdown",
              class: { "chatbot-dropdown-ready": _vm.dropdownReady },
              style: _vm.dropdownStyle,
            },
            [
              _c("div", { staticClass: "chatbot-dropdown-content" }, [
                _c("div", { staticClass: "chatbot-section-header" }, [
                  _c("div", { staticClass: "chatbot-header-left" }, [
                    _c("span", { staticClass: "chatbot-header-title" }, [
                      _vm._v(_vm._s(_vm.$t("message.chatbotStatsHeaderTitle"))),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "chatbot-info-wrapper" },
                      [
                        _c(
                          "md-icon",
                          {
                            staticClass: "chatbot-info-icon",
                            nativeOn: {
                              mouseenter: function ($event) {
                                return _vm.showInfoTooltip.apply(
                                  null,
                                  arguments
                                )
                              },
                              mouseleave: function ($event) {
                                return _vm.hideInfoTooltip.apply(
                                  null,
                                  arguments
                                )
                              },
                            },
                          },
                          [_vm._v("info_outline")]
                        ),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "chatbot-status-indicator",
                      class: _vm.getStatusClass(),
                    },
                    [
                      _c("span", { staticClass: "chatbot-status-dot" }),
                      _vm._v(" "),
                      _c("span", { staticClass: "chatbot-status-text" }, [
                        _vm._v(_vm._s(_vm.getStatusText())),
                      ]),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "chatbot-stat-row" }, [
                  _c("div", { staticClass: "chatbot-stat-left" }, [
                    _c(
                      "div",
                      { staticClass: "chatbot-icon-box total" },
                      [
                        _c("md-icon", { staticClass: "chatbot-stat-icon" }, [
                          _vm._v("forum"),
                        ]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "chatbot-stat-details" }, [
                      _c("div", { staticClass: "chatbot-stat-title" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("message.chatbotStatTotalChatbotsTitle")
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "chatbot-stat-desc" }, [
                        _vm._v(_vm._s(_vm.$t("message.maxSessionCount"))),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "chatbot-stat-number total" }, [
                    _vm._v(
                      _vm._s(
                        (_vm.features.totalSessionCount || 0).toLocaleString()
                      )
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "chatbot-stat-row" }, [
                  _c("div", { staticClass: "chatbot-stat-left" }, [
                    _c(
                      "div",
                      { staticClass: "chatbot-icon-box free" },
                      [
                        _c("md-icon", { staticClass: "chatbot-stat-icon" }, [
                          _vm._v("card_giftcard"),
                        ]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "chatbot-stat-details" }, [
                      _c("div", { staticClass: "chatbot-stat-title" }, [
                        _vm._v(_vm._s(_vm.$t("message.chatbotStatFreeTitle"))),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "chatbot-stat-desc" }, [
                        _vm._v(_vm._s(_vm.$t("message.chatbotStatFreeDesc"))),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "chatbot-stat-number free" }, [
                    _vm._v(
                      _vm._s(
                        (_vm.features.freeSessionCount || 0).toLocaleString()
                      )
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "chatbot-stat-row" }, [
                  _c("div", { staticClass: "chatbot-stat-left" }, [
                    _c(
                      "div",
                      { staticClass: "chatbot-icon-box extra" },
                      [
                        _c("md-icon", { staticClass: "chatbot-stat-icon" }, [
                          _vm._v("bolt"),
                        ]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "chatbot-stat-details" }, [
                      _c("div", { staticClass: "chatbot-stat-title" }, [
                        _vm._v(_vm._s(_vm.$t("message.chatbotStatExtraTitle"))),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "chatbot-stat-desc" }, [
                        _vm._v(_vm._s(_vm.$t("message.chatbotStatExtraDesc"))),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "chatbot-stat-number extra" }, [
                    _vm._v(
                      _vm._s(
                        (_vm.features.extraSessionCount || 0).toLocaleString()
                      )
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "chatbot-stat-row chatbot-expandable",
                    on: {
                      click: function ($event) {
                        _vm.usageExpanded = !_vm.usageExpanded
                      },
                    },
                  },
                  [
                    _c("div", { staticClass: "chatbot-stat-left" }, [
                      _c(
                        "div",
                        { staticClass: "chatbot-icon-box used" },
                        [
                          _c("md-icon", { staticClass: "chatbot-stat-icon" }, [
                            _vm._v("check_circle"),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "chatbot-stat-details" }, [
                        _c(
                          "div",
                          { staticClass: "chatbot-stat-title" },
                          [
                            _vm._v(
                              "\n                            " +
                                _vm._s(_vm.$t("message.chatbotStatUsedTitle")) +
                                "\n                            "
                            ),
                            _c(
                              "md-icon",
                              {
                                staticClass: "chatbot-expand-icon",
                                class: { expanded: _vm.usageExpanded },
                              },
                              [_vm._v("expand_more")]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "chatbot-stat-desc" }, [
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.getUsagePercentage().toFixed(1)) +
                              _vm._s(
                                _vm.$t("message.chatbotPercentUsedSuffix")
                              ) +
                              "\n                        "
                          ),
                        ]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "chatbot-stat-number used" }, [
                      _vm._v(
                        _vm._s((_vm.totalChatbotUsage || 0).toLocaleString())
                      ),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _vm.usageExpanded
                  ? _c("div", { staticClass: "chatbot-usage-breakdown" }, [
                      _c("div", { staticClass: "chatbot-breakdown-row" }, [
                        _c("div", { staticClass: "chatbot-breakdown-left" }, [
                          _c("span", {
                            staticClass: "chatbot-breakdown-dot free",
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            { staticClass: "chatbot-breakdown-label" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("message.chatbotBreakdownFreeCredits")
                                )
                              ),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "span",
                          { staticClass: "chatbot-breakdown-value free" },
                          [
                            _vm._v(
                              _vm._s((_vm.usedFromFree || 0).toLocaleString())
                            ),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "chatbot-breakdown-row" }, [
                        _c("div", { staticClass: "chatbot-breakdown-left" }, [
                          _c("span", {
                            staticClass: "chatbot-breakdown-dot normal",
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            { staticClass: "chatbot-breakdown-label" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("message.chatbotBreakdownNormalPlan")
                                )
                              ),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "span",
                          { staticClass: "chatbot-breakdown-value normal" },
                          [
                            _vm._v(
                              _vm._s((_vm.usedFromNormal || 0).toLocaleString())
                            ),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "chatbot-breakdown-row" }, [
                        _c("div", { staticClass: "chatbot-breakdown-left" }, [
                          _c("span", {
                            staticClass: "chatbot-breakdown-dot extra",
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            { staticClass: "chatbot-breakdown-label" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("message.chatbotBreakdownExtraPlan")
                                )
                              ),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "span",
                          { staticClass: "chatbot-breakdown-value extra" },
                          [
                            _vm._v(
                              _vm._s((_vm.usedFromExtra || 0).toLocaleString())
                            ),
                          ]
                        ),
                      ]),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "chatbot-stat-row" }, [
                  _c("div", { staticClass: "chatbot-stat-left" }, [
                    _c(
                      "div",
                      {
                        staticClass: "chatbot-icon-box remaining",
                        class: _vm.getStatusClass(),
                      },
                      [
                        _c("md-icon", { staticClass: "chatbot-stat-icon" }, [
                          _vm._v("trending_up"),
                        ]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "chatbot-stat-details" }, [
                      _c("div", { staticClass: "chatbot-stat-title" }, [
                        _vm._v(
                          _vm._s(_vm.$t("message.chatbotStatRemainingTitle"))
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "chatbot-stat-desc" }, [
                        _vm._v(
                          _vm._s(_vm.$t("message.chatbotStatRemainingDesc"))
                        ),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "chatbot-stat-number remaining",
                      class: _vm.getStatusClass(),
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.getRemainingSessionCount().toLocaleString()
                          ) +
                          "\n                "
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "chatbot-progress-wrapper" }, [
                  _c("div", { staticClass: "chatbot-progress-container" }, [
                    _c("div", { staticClass: "chatbot-progress-bg" }, [
                      _c("div", {
                        staticClass: "chatbot-progress-fill",
                        class: _vm.getStatusClass(),
                        style: { width: _vm.getUsagePercentage() + "%" },
                      }),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "chatbot-divider" }),
                _vm._v(" "),
                _c("div", { staticClass: "chatbot-section-header" }, [
                  _c("span", { staticClass: "chatbot-header-title" }, [
                    _vm._v(
                      _vm._s(_vm.$t("message.chatbotAutomationSectionTitle"))
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "chatbot-status-indicator",
                      class: _vm.getAutomationStatusClass(),
                    },
                    [
                      _c("span", { staticClass: "chatbot-status-dot" }),
                      _vm._v(" "),
                      _c("span", { staticClass: "chatbot-status-text" }, [
                        _vm._v(_vm._s(_vm.getAutomationStatusText())),
                      ]),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "chatbot-stat-row" }, [
                  _c("div", { staticClass: "chatbot-stat-left" }, [
                    _c(
                      "div",
                      { staticClass: "chatbot-icon-box automation" },
                      [
                        _c("md-icon", { staticClass: "chatbot-stat-icon" }, [
                          _vm._v("smart_toy"),
                        ]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "chatbot-stat-details" }, [
                      _c("div", { staticClass: "chatbot-stat-title" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("message.chatbotStatTotalAutomationTitle")
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "chatbot-stat-desc" }, [
                        _vm._v(_vm._s(_vm.$t("message.maxAutomationTask"))),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "chatbot-stat-number automation" }, [
                    _vm._v(
                      _vm._s(
                        (_vm.features.maxAutomationTask || 0).toLocaleString()
                      )
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "chatbot-stat-row" }, [
                  _c("div", { staticClass: "chatbot-stat-left" }, [
                    _c(
                      "div",
                      { staticClass: "chatbot-icon-box used-automation" },
                      [
                        _c("md-icon", { staticClass: "chatbot-stat-icon" }, [
                          _vm._v("task_alt"),
                        ]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "chatbot-stat-details" }, [
                      _c("div", { staticClass: "chatbot-stat-title" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("message.chatbotStatUsedAutomationTitle")
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "chatbot-stat-desc" }, [
                        _vm._v(
                          "\n                            " +
                            _vm._s(
                              _vm.getAutomationUsagePercentage().toFixed(1)
                            ) +
                            _vm._s(_vm.$t("message.chatbotPercentUsedSuffix")) +
                            "\n                        "
                        ),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "chatbot-stat-number used-automation" },
                    [
                      _vm._v(
                        _vm._s((_vm.totalAutomationUsage || 0).toLocaleString())
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "chatbot-stat-row" }, [
                  _c("div", { staticClass: "chatbot-stat-left" }, [
                    _c(
                      "div",
                      {
                        staticClass: "chatbot-icon-box remaining-auto",
                        class: _vm.getAutomationStatusClass(),
                      },
                      [
                        _c("md-icon", { staticClass: "chatbot-stat-icon" }, [
                          _vm._v("hourglass_empty"),
                        ]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "chatbot-stat-details" }, [
                      _c("div", { staticClass: "chatbot-stat-title" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "message.chatbotStatRemainingAutomationTitle"
                            )
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "chatbot-stat-desc" }, [
                        _vm._v(
                          _vm._s(_vm.$t("message.remainingAutomationTask"))
                        ),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "chatbot-stat-number remaining-auto",
                      class: _vm.getAutomationStatusClass(),
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.getRemainingAutomationTask().toLocaleString()
                          ) +
                          "\n                "
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "chatbot-progress-wrapper" }, [
                  _c("div", { staticClass: "chatbot-progress-container" }, [
                    _c("div", { staticClass: "chatbot-progress-bg" }, [
                      _c("div", {
                        staticClass: "chatbot-progress-fill",
                        class: _vm.getAutomationStatusClass(),
                        style: {
                          width: _vm.getAutomationUsagePercentage() + "%",
                        },
                      }),
                    ]),
                  ]),
                ]),
              ]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.infoTooltipVisible
        ? _c(
            "div",
            {
              staticClass: "chatbot-info-tooltip-fixed",
              style: _vm.infoTooltipStyle,
            },
            [
              _c("div", { staticClass: "tooltip-title" }, [
                _vm._v(
                  _vm._s(_vm.$t("message.chatbotUsagePriorityTooltipTitle"))
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "tooltip-item" }, [
                _c("span", { staticClass: "tooltip-badge free" }, [
                  _vm._v("1"),
                ]),
                _vm._v(" "),
                _c("span", [
                  _vm._v(_vm._s(_vm.$t("message.chatbotUsagePriorityStep1"))),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "tooltip-item" }, [
                _c("span", { staticClass: "tooltip-badge normal" }, [
                  _vm._v("2"),
                ]),
                _vm._v(" "),
                _c("span", [
                  _vm._v(_vm._s(_vm.$t("message.chatbotUsagePriorityStep2"))),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "tooltip-item" }, [
                _c("span", { staticClass: "tooltip-badge extra" }, [
                  _vm._v("3"),
                ]),
                _vm._v(" "),
                _c("span", [
                  _vm._v(_vm._s(_vm.$t("message.chatbotUsagePriorityStep3"))),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "tooltip-note" }, [
                _vm._v(_vm._s(_vm.$t("message.chatbotUsagePriorityNote"))),
              ]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isDropdownVisible
        ? _c("div", {
            staticClass: "dropdown-backdrop",
            on: { click: _vm.closeDropdown },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }